import { defineMessages } from 'react-intl';

export default defineMessages({
  pointAtTheEnd: {
    id: 'Sla.shipping.pointAtTheEnd',
    defaultMessage: '.',
  },
  shippingLegend4: {
    id: 'Sla.shipping.legend4',
    defaultMessage: 'Note: ',
  },
  shippingLegend5: {
    id: 'Sla.shipping.legend5',
    defaultMessage: 'Shipping may be impacted by carrier delays',
  },
  shippingLegend6: {
    id: 'Sla.shipping.legend6',
    defaultMessage:
      'Two Shipping Options Available (shipping may be impacted by carrier delays):',
  },
  pdpStandardLegend: {
    id: 'Sla.shipping.pdpStandardLegend',
    defaultMessage: 'Ships free in',
  },
  pdpWhitegloveLegend: {
    id: 'Sla.shipping.pdpWhitegloveLegend',
    defaultMessage: 'Free in-home setup in',
  },
  pdpOverwriteWhitegloveLegend: {
    id: 'Sla.shipping.pdpOverwriteWhitegloveLegend',
    defaultMessage: 'Free delivery in',
  },
  fallbackMessage: {
    id: 'Sla.slaFallback',
    defaultMessage: 'Leaves warehouse in ',
  },
  estimatedMessage: {
    id: 'Sla.estimatedMessage',
    defaultMessage: 'Estimated ',
  },
  estimatedInHomeMessage: {
    id: 'Sla.estimatedInHomeMessage',
    defaultMessage: 'In-Home Setup in',
  },
  estimatedStandardMessage: {
    id: 'Sla.estimatedStandardMessage',
    defaultMessage: 'Ships in',
  },
  estimatedStandardMessage7to10Days: {
    id: 'Sla.estimatedStandardMessage7to10Days',
    defaultMessage: 'Delivery',
  },
  estimatedExpressMessage: {
    id: 'Sla.estimatedExpressMessage',
    defaultMessage: '1 to 2',
  },
  daysMessage: {
    id: 'Sla.daysMessage',
    defaultMessage: 'business days',
  },
  standardMessage: {
    id: 'Sla.standardMessage',
    defaultMessage: 'Standard shipping: leaves warehouse in ',
  },
  inHomeMessage: {
    id: 'Sla.inHomeMessage',
    defaultMessage: 'Receive in-home setup in ',
  },
});
